import React from 'react'
import { useNavigate } from 'react-router-dom'

const EventHeader = ({ event, user, onEditClick, onDeleteClick, onFlyerUpdateClick }) => {
  const navigate = useNavigate()

  const isOwner = event?.createdBy?._id?.toString() === user?.id?.toString()

  return (
    <div className="flex items-center justify-between gap-3 flex-wrap">
      <button
        onClick={() => navigate('/home')}
        className="bg-white/10 hover:bg-white/20 text-white font-medium py-2 px-4 rounded-lg border border-white/20 hover:border-white/40 transition-all duration-300"
      >
        ← Back to Dashboard
      </button>

      <div className="flex gap-3 flex-wrap">
        {/* Open to everyone with access: the schedule is read-only for
            non-owners, who can still see when each set is. */}
        <button
          onClick={() => navigate(`/event/${event._id}/schedule`)}
          className="bg-white/10 hover:bg-white/20 text-white font-medium py-2 px-4 rounded-lg border border-white/20 hover:border-white/40 transition-all duration-300"
        >
          🗓 Schedule
        </button>

        {isOwner && (
          <>
            <button
              onClick={onFlyerUpdateClick}
              className="bg-white/10 hover:bg-white/20 text-white font-medium py-2 px-4 rounded-lg border border-white/20 hover:border-white/40 transition-all duration-300"
            >
              📄 Update from Flyer
            </button>
            <button
              onClick={onDeleteClick}
              className="bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded-lg transition-all duration-300"
            >
              🗑️ Delete Event
            </button>
            <button
              onClick={onEditClick}
              className="bg-purple-600 hover:bg-purple-700 text-white font-medium py-2 px-4 rounded-lg transition-all duration-300"
            >
              ✏️ Edit Event
            </button>
          </>
        )}
      </div>
    </div>
  )
}

export default EventHeader